// "Lượt xem" hiển thị = số ảo suy ra từ tương tác × hệ số, để tạo thu hút giai đoạn đầu.
// View thật hiện = 0 (FE chưa track), nên đây là số trang trí, TẤT ĐỊNH theo từng bài.
// Đông user rồi thì GIẢM hệ số ở ĐÂY (10 → 5 → 2 → 1) — chỉ sửa 1 dòng.
export const VIEW_MULTIPLIER = 10;

// hash tất định từ id (djb2) → jitter 0..59 để 2 bài cùng tương tác không hiện số trùng nhau
const seedFromId = (id: string): number => {
  let h = 5381;
  for (let i = 0; i < id.length; i += 1) h = ((h << 5) + h + id.charCodeAt(i)) >>> 0;
  return h % 60;
};

const toNum = (v: unknown): number => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

type ViewablePost = {
  id?: string;
  shortId?: string;
  likesCount?: string | number;
  voteUpCount?: number;
  commentsCount?: string | number;
  createdAt?: string | Date;
};

export const getDisplayViews = (post?: ViewablePost | null): number => {
  if (!post) return 0;
  const id = String(post.id ?? post.shortId ?? '');
  const likes = toNum(post.likesCount) + toNum(post.voteUpCount);
  const comments = toNum(post.commentsCount);
  const ageDays = post.createdAt
    ? Math.max(0, (Date.now() - new Date(post.createdAt).getTime()) / 86_400_000)
    : 0;
  // sàn 20 → mọi bài (kể cả mới, 0 tương tác) vẫn hiện ~200–790 lượt sau khi ×10
  const base = 20 + likes * 8 + comments * 12 + Math.floor(ageDays) * 2 + seedFromId(id);
  return Math.round(base * VIEW_MULTIPLIER);
};

export const formatViews = (post?: ViewablePost | null): string =>
  getDisplayViews(post).toLocaleString('vi-VN');
